<app-loader [loading]="isLoading" type="authRedirect"></app-loader>

<ng-container *ngIf="!isLoading">
  <div class="centered-square-container">
    <!-- Failed redirect logins surface the (already localized) reason instead
         of a misleading waiting message. -->
    <p *ngIf="errorMessage" class="auth-redirect-error" role="alert">{{ errorMessage }}</p>
    <p *ngIf="!errorMessage">{{ 'app.auth_redirect.please_wait_redirect' | translate }}</p>
  </div>
</ng-container>
